import NotFoundPage from '@brands/Dashboard/NotFoundPage/NotFoundPage';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import React from 'react';
import { Outlet } from 'react-router-dom';

const ADMIN_ROLES: ReadonlySet<string> = new Set([
  UserRoleName.Admin,
  UserRoleName.SuperAdmin,
  UserRoleName.OrganizationAdmin,
  UserRoleName.Collector,
]);


const RequireAdminRole: React.FC = () => {
  const { userInfo } = useAppSelector(selectAuth);

  if (!userInfo || !ADMIN_ROLES.has(userInfo.role.name)) {
    return <NotFoundPage />;
  }

  return <Outlet />;
};

export default RequireAdminRole;
